import React from 'react'
import DOMPurify from 'dompurify'
// @ts-ignore
import classnames from 'classnames'
import { RTECompoundProps } from './RTECompound.types'

export const RTECompound = (props: RTECompoundProps) => {
  const { content, checkmarks, shouldGrow } = props

  return (
    <div
      className={classnames(
        'Content content-block',
        {
          checkmarks: checkmarks === 'true',
        },
        {
          ['u-flexGrow']: shouldGrow,
        }
      )}
      dangerouslySetInnerHTML={{
        __html: DOMPurify.sanitize(content ?? ''),
      }}></div>
  )
}
